// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { getSession, getDrivers, getDriverDetails, getVehicles, getVehicleDetails } from "../api";
// import "../assets/css/global.css";

// function Dashboard() {
//   // Stato per gestire l'utente, i corrieri e la ricerca
//   const [user, setUser] = useState(null);
//   const [drivers, setDrivers] = useState([]); // Lista completa dei corrieri
//   const [searchDriverTerm, setSearchDriverTerm] = useState(""); // Testo di ricerca
//   const [selectedDriver, setSelectedDriver] = useState(null); // Corriere selezionato
//   const [vehicles, setVehicles] = useState([]); // Lista completa dei veicoli
//   const [searchVehicleTerm, setSearchVehicleTerm] = useState(""); // Testo di ricerca
//   const [selectedVehicle, setSelectedVehicle] = useState(null); // veicolo selezionato
//   const navigate = useNavigate();

//   // Controllo della sessione utente
//   useEffect(() => {
//     getSession()
//       .then((res) => {
//         if (res.data.user) {
//           setUser(res.data.user);
//         } else {
//           navigate("/?error=Sessione Utente Inesistente");
//         }
//       })
//       .catch(() => navigate("/?error=Sessione Utente Inesistente"));
//   }, [navigate]);

//   // Recupero della lista dei corrieri da MongoDB
//   useEffect(() => {
//     getDrivers()
//       .then((res) => {
//         // console.log("Dati ricevuti da /api/drivers:", res.data);
//         if (Array.isArray(res.data)) {
//           setDrivers(res.data);
//         } else {
//           // console.error("Errore: La risposta non è un array", res.data);
//           setDrivers([]); // Evitiamo errori
//         }
//       })
//       .catch((error) => {
//         // console.error("Errore nel recupero dei corrieri:", error);
//         setDrivers([]); // In caso di errore, lista vuota
//       });
//   }, []);

//   // Filtraggio dei corrieri in base alla ricerca
//   const filteredDrivers = drivers.filter((driver) =>
//     `${driver.name} ${driver.surname}`.toLowerCase().includes(searchDriverTerm.toLowerCase())
//   );
//   // console.log("Lista filtrata dei corrieri:", filteredDrivers);

//   const handleSelectDriver = (driver) => {
//     // console.log("Selezionato corriere:", driver);
//     getDriverDetails(driver._id)
//       .then((res) => {
//         // console.log("Dati corriere ricevuti:", res.data);
//         setSelectedDriver(res.data);
//       })
//       .catch((err) => console.error("Errore nel recupero dettagli corriere:", err));
//   };
  
//   useEffect(() => {
//     // console.log("Stato aggiornato, corriere selezionato:", selectedDriver);
//   }, [selectedDriver]);

//   // Filtraggio dei corrieri in base alla ricerca
//   const filteredVehicles = vehicles.filter((vehicle) =>
//     `${vehicle.license_plate} - ${vehicle.brand} ${vehicle.model}`.toLowerCase().includes(searchVehicleTerm.toLowerCase())
//   );
//   // console.log("Lista filtrata dei corrieri:", filteredVehicles);

//   // Recupero della lista dei corrieri da MongoDB
//   useEffect(() => {
//     getVehicles()
//       .then((res) => {
//         // console.log("Dati ricevuti da /api/vehicles:", res.data);
//         if (Array.isArray(res.data)) {
//           setVehicles(res.data);
//         } else {
//           // console.error("Errore: La risposta non è un array", res.data);
//           setVehicles([]); // Evitiamo errori
//         }
//       })
//       .catch((error) => {
//         // console.error("Errore nel recupero dei veicoli:", error);
//         setVehicles([]); // In caso di errore, lista vuota
//       });
//   }, []);

//   const handleSelectVehicle = (vehicle) => {
//     // console.log("Selezionato veicolo:", vehicle);
//     getVehicleDetails(vehicle._id)
//       .then((res) => {
//         // console.log("Dati veicolo ricevuti:", res.data);
//         setSelectedVehicle(res.data);
//       })
//       .catch((err) => console.error("Errore nel recupero dettagli veicolo:", err));
//   };

//   useEffect(() => {
//     // console.log("Stato aggiornato, veicolo selezionato:", selectedVehicle);
//   }, [selectedVehicle]);

//   return (
//     <main className="dashboard_container">
//       <div className="dashboard_desk" id="driver_section">
//         <div className="dashboard_search">
//           <div className="dashboard_searchbar">
//             <input
//               type="text"
//               id="search_drivers"
//               placeholder="Cerca Corriere.."
//               value={searchDriverTerm}
//               onChange={(e) => setSearchDriverTerm(e.target.value)}
//               autoComplete="off"
//             />
//             <button onClick={() => setSearchDriverTerm("")}>Reset</button>
//           </div>
//           <div className="dashboard_list" id="drivers_list">
//             <ul>
//               {Array.isArray(filteredDrivers) && filteredDrivers.length > 0 ? (
//                 filteredDrivers.map((driver) => (
//                   <li key={driver._id} onClick={() => handleSelectDriver(driver)}>
//                     {driver.name && driver.surname
//                       ? `${driver.name} ${driver.surname}`
//                       : "Dati non disponibili"}
//                   </li>
//                 ))
//               ) : (
//                 <li>Nessun corriere trovato.</li>
//               )}
//             </ul>
//           </div>
//         </div>
//         <div className="dashboard_details" id="details_drivers">
//           {selectedDriver ? (
//             <>
//               <div className="dashboard_box">
//                 <ul>
//                   <li>Nominativo:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.name} {selectedDriver.surname}</li>
//                   <li>Matricola:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.serial_number || "** Non Registrato **"}</li>
//                   <li>Contatto:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.contact_number || "** Non Registrato **"}</li>
//                   <li>Codice Patente:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.license_code || "** Non Registrato **"}</li>
//                   <li>Tipo Patente:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.license_type || "** Non Registrato **"}</li>
//                   <li>Scadenza Patente:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.license_expiration || "** Non Registrato **"}</li>
//                 </ul>
//               </div>
//               <div className="dashboard_box">
//                 <div className="dashboard_profile">
//                   <img 
//                     src={selectedDriver.profile_photo 
//                       ? (`${process.env.REACT_APP_API_URL}${selectedDriver.profile_photo}`)
//                       : (`${process.env.PUBLIC_URL}/media/drivers/driver_default.svg`)
//                     }
//                     alt="Profilo Autista" 
//                   />
//                 </div>
//                 <button id="driver_registry">Anagrafica</button>
//                 <button id="driver_documents">Documenti</button>
//                 <button id="driver_attendance">Presenze</button>
//                 <button id="driver_connect">Associa</button>
//               </div>
//               <div className="dashboard_box">
//                 <ul>
//                   <li>Tipo Contratto:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.contract_type || "** Non Registrato **"}</li>
//                   <li>Scadenza Contratto:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.contract_expiration || "** Non Registrato **"}</li>
//                 </ul>
//               </div>
//             </>
//           ) : (
//             <>
//               <div className="dashboard_box">
//                 <ul>
//                   <li>Nominativo:</li>
//                   <li>Selezionare un Autista...</li>
//                   <li>Matricola:</li>
//                   <li>Selezionare un Autista...</li>
//                   <li>Contatto:</li>
//                   <li>Selezionare un Autista...</li>
//                   <li>Codice Patente:</li>
//                   <li>Selezionare un Autista...</li>
//                   <li>Tipo Patente:</li>
//                   <li>Selezionare un Autista...</li>
//                   <li>Scadenza Patente:</li>
//                   <li>Selezionare un Autista...</li>
//                 </ul>
//               </div>
//               <div className="dashboard_box">
//                 <div className="dashboard_profile">
//                   <img src={`${process.env.PUBLIC_URL}/images/svg/driver_null.svg`} alt="Profilo Autista" />
//                 </div>
//                 <button id="driver_registry">Anagrafica</button>
//                 <button id="driver_documents">Documenti</button>
//                 <button id="driver_attendance">Presenze</button>
//                 <button id="driver_connect">Associa</button>
//               </div>
//               <div className="dashboard_box">
//                 <ul>
//                   <li>Tipo Contratto:</li>
//                   <li>Selezionare un Autista...</li>
//                   <li>Scadenza Contratto:</li>
//                   <li>Selezionare un Autista...</li>
//                 </ul>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//       <div className="dashboard_desk" id="vehicle_section">
//         <div className="dashboard_search">
//           <div className="dashboard_searchbar">
//             <input
//                 type="text"
//                 id="search_vehicles"
//                 placeholder="Cerca Veicolo.."
//                 value={searchVehicleTerm}
//                 onChange={(e) => setSearchVehicleTerm(e.target.value)}
//                 autoComplete="off"
//               />
//             <button onClick={() => setSearchVehicleTerm("")}>Reset</button>
//           </div>
//           <div className="dashboard_list" id="vehicles_list">
//             <ul>
//               {Array.isArray(filteredVehicles) && filteredVehicles.length > 0 ? (
//                 filteredVehicles.map((vehicle) => (
//                   <li key={vehicle._id} onClick={() => handleSelectVehicle(vehicle)}>
//                     {vehicle.license_plate && vehicle.brand && vehicle.model
//                       ? `${vehicle.license_plate} - ${vehicle.brand} ${vehicle.model}`
//                       : "Dati non disponibili"}
//                   </li>
//                 ))
//               ) : (
//                 <li>Nessun veicolo trovato.</li>
//               )}
//             </ul>
//           </div>
//         </div>
//         <div className="dashboard_details" id="details_vehicles">
//           {selectedVehicle ? (
//             <>
//               <div className="dashboard_box">
//                 <ul>
//                   <li>Targa:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.license_plate}</li>
//                   <li>Marca:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.brand}</li>
//                   <li>Modello:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.model}</li>
//                   <li>Km Registrati:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.km_registered || "** Non Registrato **"}</li>
//                   <li>Carburante Registrato:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.fuel_registered || "** Non Registrato **"}</li>
//                   <li>Pneumatici:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.tires_type || "** Non Registrato **"}</li>
//                 </ul>
//               </div>
//               <div className="dashboard_box">
//                 <div className="dashboard_profile">
//                   <img 
//                     src={selectedVehicle.profile_photo
//                       ? (`${process.env.REACT_APP_API_URL}${selectedVehicle.profile_photo}`)
//                       : (`${process.env.PUBLIC_URL}/media/vehicles/vehicle_default.svg`)
//                     }
//                     alt="Profilo Veicolo" 
//                   />
//                 </div>
//                 <button id="vehicle_registry">Anagrafica</button>
//                 <button id="vehicle_attachments">Allegati</button>
//                 <button id="vehicle_workshop">Officina</button>
//                 <button id="vehicle_connect">Associa</button>
//               </div>
//               <div className="dashboard_box">
//                 <ul>
//                   <li>Ultima Revisione:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.last_revision_date || "** Non Registrato **"}</li>
//                   <li>Ultimo Tagliando:</li>
//                   <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.last_service_date || "** Non Registrato **"}</li>
//                 </ul>
//               </div>
//             </>
//           ) : (
//             <>
//               <div className="dashboard_box">
//                 <ul>
//                   <li>Targa:</li>
//                   <li>Selezionare un Veicolo...</li>
//                   <li>Marca:</li>
//                   <li>Selezionare un Veicolo...</li>
//                   <li>Modello:</li>
//                   <li>Selezionare un Veicolo...</li>
//                   <li>Km Registrati:</li>
//                   <li>Selezionare un Veicolo...</li>
//                   <li>Carburante Registrato:</li>
//                   <li>Selezionare un Veicolo...</li>
//                   <li>Pneumatici:</li>
//                   <li>Selezionare un Veicolo...</li>
//                 </ul>
//               </div>
//               <div className="dashboard_box">
//                 <div className="dashboard_profile">
//                   <img src={`${process.env.PUBLIC_URL}/images/svg/vehicle_null.svg`} alt="Profilo Veicolo" />
//                 </div>
//                 <button id="vehicle_registry">Anagrafica</button>
//                 <button id="vehicle_attachments">Allegati</button>
//                 <button id="vehicle_workshop">Officina</button>
//                 <button id="vehicle_connect">Associa</button>
//               </div>
//               <div className="dashboard_box">
//                 <ul>
//                   <li>Scadenza Revisione:</li>
//                   <li>Selezionare un Veicolo...</li>
//                   <li>Scadenza Tagliando:</li>
//                   <li>Selezionare un Veicolo...</li>
//                 </ul>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </main>
//   );
// }

// export default Dashboard;

// _______________________________________________________________________________________________________________________________

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getSession, getDrivers, getDriverDetails, getVehicles, getVehicleDetails } from "../api";
import "../assets/css/global.css";
import "../assets/css/overlay.css";

function Dashboard() {
  // Stato per gestire l'utente, i corrieri e la ricerca
  const [user, setUser] = useState(null);
  const [drivers, setDrivers] = useState([]); // Lista completa dei corrieri
  const [searchDriverTerm, setSearchDriverTerm] = useState(""); // Testo di ricerca
  const [selectedDriver, setSelectedDriver] = useState(null); // Corriere selezionato
  const [vehicles, setVehicles] = useState([]); // Lista completa dei veicoli
  const [searchVehicleTerm, setSearchVehicleTerm] = useState(""); // Testo di ricerca
  const [selectedVehicle, setSelectedVehicle] = useState(null); // veicolo selezionato
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  // Stato per la finestra modale
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  // Funzione per aprire la modale
  const openModal = (content) => {
    setModalContent(content);
    setShowModal(true);
  };

  // Funzione per chiudere la modale
  const closeModal = () => {
    setShowModal(false);
    setModalContent("");
  };

  const handleInputChange = (e) => {
    setSelectedDriver({ ...selectedDriver, [e.target.name]: e.target.value });
  };

  const handleSaveChanges = () => {
    updateDriver(selectedDriver._id, selectedDriver)
      .then(() => {
        alert("Dati salvati con successo!");
        setIsModalOpen(false);
      })
      .catch(() => alert("Errore nel salvataggio dei dati"));
  };
  
  // Controllo della sessione utente
  useEffect(() => {
    getSession()
      .then((res) => {
        if (res.data.user) {
          setUser(res.data.user);
        } else {
          navigate("/?error=Sessione Utente Inesistente");
        }
      })
      .catch(() => navigate("/?error=Sessione Utente Inesistente"));
  }, [navigate]);

  // Recupero della lista dei corrieri da MongoDB
  useEffect(() => {
    getDrivers()
      .then((res) => {
        // console.log("Dati ricevuti da /api/drivers:", res.data);
        if (Array.isArray(res.data)) {
          setDrivers(res.data);
        } else {
          // console.error("Errore: La risposta non è un array", res.data);
          setDrivers([]); // Evitiamo errori
        }
      })
      .catch((error) => {
        // console.error("Errore nel recupero dei corrieri:", error);
        setDrivers([]); // In caso di errore, lista vuota
      });
  }, []);

  // Filtraggio dei corrieri in base alla ricerca
  const filteredDrivers = drivers.filter((driver) =>
    `${driver.name} ${driver.surname}`.toLowerCase().includes(searchDriverTerm.toLowerCase())
  );
  // console.log("Lista filtrata dei corrieri:", filteredDrivers);

  const handleSelectDriver = (driver) => {
    // console.log("Selezionato corriere:", driver);
    getDriverDetails(driver._id)
      .then((res) => {
        // console.log("Dati corriere ricevuti:", res.data);
        setSelectedDriver(res.data);
      })
      .catch((err) => console.error("Errore nel recupero dettagli corriere:", err));
  };
  
  // Filtraggio dei corrieri in base alla ricerca
  const filteredVehicles = vehicles.filter((vehicle) =>
    `${vehicle.license_plate} - ${vehicle.brand} ${vehicle.model}`.toLowerCase().includes(searchVehicleTerm.toLowerCase())
  );
  // console.log("Lista filtrata dei corrieri:", filteredVehicles);

  // Recupero della lista dei corrieri da MongoDB
  useEffect(() => {
    getVehicles()
      .then((res) => {
        // console.log("Dati ricevuti da /api/vehicles:", res.data);
        if (Array.isArray(res.data)) {
          setVehicles(res.data);
        } else {
          // console.error("Errore: La risposta non è un array", res.data);
          setVehicles([]); // Evitiamo errori
        }
      })
      .catch((error) => {
        // console.error("Errore nel recupero dei veicoli:", error);
        setVehicles([]); // In caso di errore, lista vuota
      });
  }, []);

  const handleSelectVehicle = (vehicle) => {
    // console.log("Selezionato veicolo:", vehicle);
    getVehicleDetails(vehicle._id)
      .then((res) => {
        // console.log("Dati veicolo ricevuti:", res.data);
        setSelectedVehicle(res.data);
      })
      .catch((err) => console.error("Errore nel recupero dettagli veicolo:", err));
  };

  return (
    <main className="dashboard_container">
      <div className="dashboard_desk" id="driver_section">
        <div className="dashboard_search">
          <div className="dashboard_searchbar">
            <input
              type="text"
              id="search_drivers"
              placeholder="Cerca Corriere.."
              value={searchDriverTerm}
              onChange={(e) => setSearchDriverTerm(e.target.value)}
              autoComplete="off"
            />
            <button onClick={() => setSearchDriverTerm("")}>Reset</button>
          </div>
          <div className="dashboard_list" id="drivers_list">
            <ul>
              {Array.isArray(filteredDrivers) && filteredDrivers.length > 0 ? (
                filteredDrivers.map((driver) => (
                  <li key={driver._id} onClick={() => handleSelectDriver(driver)}>
                    {driver.name && driver.surname
                      ? `${driver.name} ${driver.surname}`
                      : "Dati non disponibili"}
                  </li>
                ))
              ) : (
                <li>Nessun corriere trovato.</li>
              )}
            </ul>
          </div>
        </div>
        <div className="dashboard_details" id="details_drivers">
          {selectedDriver ? (
            <>
              <div className="dashboard_box">
                <ul>
                  <li>Nominativo:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.name} {selectedDriver.surname}</li>
                  <li>Matricola:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.serial_number || "** Non Registrato **"}</li>
                  <li>Contatto:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.contact_number || "** Non Registrato **"}</li>
                  <li>Codice Patente:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.license_code || "** Non Registrato **"}</li>
                  <li>Tipo Patente:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.license_type || "** Non Registrato **"}</li>
                  <li>Scadenza Patente:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.license_expiration || "** Non Registrato **"}</li>
                </ul>
              </div>
              <div className="dashboard_box">
                <div className="dashboard_profile">
                  <img 
                    src={selectedDriver.profile_photo 
                      ? (`${process.env.REACT_APP_API_URL}${selectedDriver.profile_photo}`)
                      : (`${process.env.PUBLIC_URL}/media/drivers/driver_default.svg`)
                    }
                    alt="Profilo Autista" 
                  />
                </div>
                <button id="driver_registry">Anagrafica</button>
                <button id="driver_documents">Documenti</button>
                <button id="driver_attendance">Presenze</button>
                <button id="driver_connect">Associa</button>
              </div>
              <div className="dashboard_box">
                <ul>
                  <li>Tipo Contratto:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.contract_type || "** Non Registrato **"}</li>
                  <li>Scadenza Contratto:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedDriver.contract_expiration || "** Non Registrato **"}</li>
                </ul>
              </div>
            </>
          ) : (
            <>
              <div className="dashboard_box">
                <ul>
                  <li>Nominativo:</li>
                  <li>Selezionare un Autista...</li>
                  <li>Matricola:</li>
                  <li>Selezionare un Autista...</li>
                  <li>Contatto:</li>
                  <li>Selezionare un Autista...</li>
                  <li>Codice Patente:</li>
                  <li>Selezionare un Autista...</li>
                  <li>Tipo Patente:</li>
                  <li>Selezionare un Autista...</li>
                  <li>Scadenza Patente:</li>
                  <li>Selezionare un Autista...</li>
                </ul>
              </div>
              <div className="dashboard_box">
                <div className="dashboard_profile">
                  <img src={`${process.env.PUBLIC_URL}/images/svg/driver_null.svg`} alt="Profilo Autista" />
                </div>
                <button id="driver_registry" onClick={() => openModal("Anagrafica Autista")}>Anagrafica</button>
                <button id="driver_documents" onClick={() => openModal("Documenti Autista")}>Documenti</button>
                <button id="driver_attendance" onClick={() => openModal("Presenze Autista")}>Presenze</button>
                <button id="driver_connect" onClick={() => openModal("Associa Driver a Veicolo")}>Associa</button>
              </div>
              <div className="dashboard_box">
                <ul>
                  <li>Tipo Contratto:</li>
                  <li>Selezionare un Autista...</li>
                  <li>Scadenza Contratto:</li>
                  <li>Selezionare un Autista...</li>
                </ul>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="dashboard_desk" id="vehicle_section">
        <div className="dashboard_search">
          <div className="dashboard_searchbar">
            <input
                type="text"
                id="search_vehicles"
                placeholder="Cerca Veicolo.."
                value={searchVehicleTerm}
                onChange={(e) => setSearchVehicleTerm(e.target.value)}
                autoComplete="off"
              />
            <button onClick={() => setSearchVehicleTerm("")}>Reset</button>
          </div>
          <div className="dashboard_list" id="vehicles_list">
            <ul>
              {Array.isArray(filteredVehicles) && filteredVehicles.length > 0 ? (
                filteredVehicles.map((vehicle) => (
                  <li key={vehicle._id} onClick={() => handleSelectVehicle(vehicle)}>
                    {vehicle.license_plate && vehicle.brand && vehicle.model
                      ? `${vehicle.license_plate} - ${vehicle.brand} ${vehicle.model}`
                      : "Dati non disponibili"}
                  </li>
                ))
              ) : (
                <li>Nessun veicolo trovato.</li>
              )}
            </ul>
          </div>
        </div>
        <div className="dashboard_details" id="details_vehicles">
          {selectedVehicle ? (
            <>
              <div className="dashboard_box">
                <ul>
                  <li>Targa:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.license_plate}</li>
                  <li>Marca:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.brand}</li>
                  <li>Modello:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.model}</li>
                  <li>Km Registrati:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.km_registered || "** Non Registrato **"}</li>
                  <li>Carburante Registrato:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.fuel_registered || "** Non Registrato **"}</li>
                  <li>Pneumatici:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.tires_type || "** Non Registrato **"}</li>
                </ul>
              </div>
              <div className="dashboard_box">
                <div className="dashboard_profile">
                  <img 
                    src={selectedVehicle.profile_photo
                      ? (`${process.env.REACT_APP_API_URL}${selectedVehicle.profile_photo}`)
                      : (`${process.env.PUBLIC_URL}/media/vehicles/vehicle_default.svg`)
                    }
                    alt="Profilo Veicolo" 
                  />
                </div>
                <button id="vehicle_registry">Anagrafica</button>
                <button id="vehicle_attachments">Allegati</button>
                <button id="vehicle_workshop">Officina</button>
                <button id="vehicle_connect">Associa</button>
              </div>
              <div className="dashboard_box">
                <ul>
                  <li>Ultima Revisione:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.last_revision_date || "** Non Registrato **"}</li>
                  <li>Ultimo Tagliando:</li>
                  <li style={{ color: selectedDriver ? "#000000" : "#999999" }}>{selectedVehicle.last_service_date || "** Non Registrato **"}</li>
                </ul>
              </div>
            </>
          ) : (
            <>
              <div className="dashboard_box">
                <ul>
                  <li>Targa:</li>
                  <li>Selezionare un Veicolo...</li>
                  <li>Marca:</li>
                  <li>Selezionare un Veicolo...</li>
                  <li>Modello:</li>
                  <li>Selezionare un Veicolo...</li>
                  <li>Km Registrati:</li>
                  <li>Selezionare un Veicolo...</li>
                  <li>Carburante Registrato:</li>
                  <li>Selezionare un Veicolo...</li>
                  <li>Pneumatici:</li>
                  <li>Selezionare un Veicolo...</li>
                </ul>
              </div>
              <div className="dashboard_box">
                <div className="dashboard_profile">
                  <img src={`${process.env.PUBLIC_URL}/images/svg/vehicle_null.svg`} alt="Profilo Veicolo" />
                </div>
                <button id="vehicle_registry" onClick={() => openModal("Anagrafica Veicolo")}>Anagrafica</button>
                <button id="vehicle_attachments" onClick={() => openModal("Allegati Veicolo")}>Allegati</button>
                <button id="vehicle_workshop" onClick={() => openModal("Lavori di Officina")}>Officina</button>
                <button id="vehicle_connect" onClick={() => openModal("Associa Driver a Veicolo")}>Associa</button>
              </div>
              <div className="dashboard_box">
                <ul>
                  <li>Scadenza Revisione:</li>
                  <li>Selezionare un Veicolo...</li>
                  <li>Scadenza Tagliando:</li>
                  <li>Selezionare un Veicolo...</li>
                </ul>
              </div>
            </>
          )}
        </div>
      </div>
      {/* MODAL OVERLAY - VISIBILE SOLO SE UN DRIVER È SELEZIONATO */}
      {isModalOpen && selectedDriver && (
        <div className="modal_overlay">
          <div className="modal_content">
            <button className="modal_close" onClick={() => setIsModalOpen(false)}>×</button>
            <h2>ANAGRAFICA AUTISTA</h2>
            <div className="modal_body">
              <div className="modal_fields">
                <label>Nominativo:</label>
                <input type="text" name="name" value={selectedDriver.name || ""} onChange={handleInputChange} />

                <label>Matricola:</label>
                <input type="text" name="serial_number" value={selectedDriver.serial_number || ""} onChange={handleInputChange} />

                <label>Contatto:</label>
                <input type="text" name="contact_number" value={selectedDriver.contact_number || ""} onChange={handleInputChange} />

                <label>Codice Patente:</label>
                <input type="text" name="license_code" value={selectedDriver.license_code || ""} onChange={handleInputChange} />

                <label>Tipo Patente:</label>
                <input type="text" name="license_type" value={selectedDriver.license_type || ""} onChange={handleInputChange} />

                <label>Scadenza Patente:</label>
                <input type="date" name="license_expiration" value={selectedDriver.license_expiration || ""} onChange={handleInputChange} />

                <label>Tipo Contratto:</label>
                <input type="text" name="contract_type" value={selectedDriver.contract_type || ""} onChange={handleInputChange} />

                <label>Scadenza Contratto:</label>
                <input type="date" name="contract_expiration" value={selectedDriver.contract_expiration || ""} onChange={handleInputChange} />
              </div>
              <div className="modal_image">
                <img src={selectedDriver.profile_photo || "/images/svg/driver_null.svg"} alt="Profilo Autista" />
              </div>
            </div>
            <button className="modal_save" onClick={handleSaveChanges}>Salva</button>
          </div>
        </div>
      )}
    </main>
  );
}

export default Dashboard;